import resolveConfig from 'tailwindcss/resolveConfig'
import twConfig from '../tailwind.config'
import type { PageQuery } from '#gql'

export function useGetColorThemeStyles(entry: Ref<PageQuery['entry'] | undefined>) {
  return computed(() => {
    if (!entry?.value) {
      return null
    }

    if (entry.value.is_independent) {
      // If the entry is independent, it does not have a color theme (workaround GM-94)
      return null
    }

    let colorTheme = entry.value.color_theme
    let current = entry.value

    while (!colorTheme && current.parent) {
      colorTheme = current.parent.color_theme
      current = current.parent
    }

    if (!colorTheme) {
      console.warn('No color theme found for entry:', entry.value.title)
      return null
    }

    const { theme } = resolveConfig(twConfig)
    const colors = theme.colors[colorTheme.slug]

    if (!colors) {
      console.warn(`No colors found for theme: ${colorTheme.slug}`)
      return null
    }

    // Map the colors to CSS custom properties
    const colorStyles = {}
    const shades = ['50', '100', '200', '300', '400', '500', '600']

    shades.forEach((shade) => {
      if (shade in colors) {
        colorStyles[`--color-${shade}`] = colors[shade]
      }
    })

    return colorStyles
  })
}
